<template>
  <p>
    <a v-if="is_favorited === false" v-on:click="toggleFavorite(true)">
      <i class="far fa-heart"></i>
      {{'Add to favorite'|translate}}
    </a>
    <a v-if="is_favorited === true" v-on:click="toggleFavorite(false)">
      <i class="fas fa-heart"></i>
      {{'Remove from favorite'|translate}}
    </a>
  </p>
</template>
<script>
import Utils from "@/helpers/utils";

export default {
  name: "favoriteControl",
  components: {
    
  },
  props: ["storeId"],
  data() {
    return {
      is_favorited: null
    };
  },
  watch: {
    $route(to, from) {
      console.log("from", from);
      console.log("to", to);
      this.loadInfo();
    }
  },
  methods: {
    loadInfo() {
      let data_favorite = {
        store_id: this.storeId,
        action: "status"
      };
      Utils.request(this, true, "store")
        .post(`/toggleFavorite/`, data_favorite)
        .then(data => {
          this.is_favorited = data.data.data == "favorited";
          console.log("this.is_favorited", this.is_favorited);
        });
    },
    toggleFavorite(is_add) {
      let data = {
        store_id: this.storeId,
        action: is_add ? "add" : "remove"
      };
      Utils.request(this, true, "store")
        .post(`/toggleFavorite/`, data)
        .then(data => {
          console.log("data", data);
          this.is_favorited = is_add;
        });
    }
  },
  mounted() {
    let user = Utils.getUser(this)
    if (user){
      this.loadInfo();
    }    
  }
};
</script>



// WEBPACK FOOTER //
// src/components/elements/FavoriteControl.vue